import React, { useState, useEffect } from "react";
import {
  FaSearch, FaMapMarkerAlt, FaPhone, FaEnvelope,
  FaStar, FaEye, FaWhatsapp, FaSpinner, FaTimes,
  FaCrown, FaArrowRight, FaFire, FaBullhorn,
  FaAd, FaGem, FaTag, FaPercent, FaHeart,
  FaChevronLeft, FaChevronRight, FaRegStar,
  FaShareAlt, FaCheckCircle
} from "react-icons/fa";
import Footer from "../../Footer/Footer";
import LoginHeader from "../../LoginHeader/LoginHeader";
import { Select, message } from "antd";
import { PromotionsGet, TrackPromotion } from "../../../Api/CoreApi";
import { BASE_API } from "../../../Api/Api";

const { Option } = Select;

const Promotions = () => {
  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedCity, setSelectedCity] = useState("all");
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [favorites, setFavorites] = useState([]);

  const baseurl = BASE_API;

  const categories = {
    all: { icon: "✨", label: "All Services", color: "#ff0055" },
    venue: { icon: "🏛️", label: "Venues", color: "#8b5cf6" },
    photography: { icon: "📸", label: "Photography", color: "#3b82f6" },
    makeup: { icon: "💄", label: "Makeup", color: "#ec4899" },
    fashion: { icon: "👗", label: "Fashion", color: "#a855f7" },
    catering: { icon: "🍽️", label: "Catering", color: "#ef4444" },
    decoration: { icon: "🌸", label: "Decoration", color: "#f59e0b" },
    entertainment: { icon: "🎵", label: "Music & DJ", color: "#10b981" },
    transportation: { icon: "🚗", label: "Transport", color: "#0ea5e9" },
    planning: { icon: "💼", label: "Planners", color: "#6366f1" },
    religious: { icon: "🛕", label: "Pandit Ji", color: "#f97316" },
  };

  useEffect(() => {
    fetchVendors();
    const saved = JSON.parse(localStorage.getItem("ad_favorites") || "[]");
    setFavorites(saved);
  }, []);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedCategory, selectedCity, vendors]);

  const fetchVendors = async () => {
    setLoading(true);
    try {
      const data = await PromotionsGet();
      if (Array.isArray(data) && data.length > 0) {
        const formatted = data.map(item => ({
          id: item.id,
          vendor_name: item.vendor_name || "Vendor",
          business_name: item.business_name || item.vendor_name || "Business",
          category: item.category || "venue",
          description: item.description || "",
          image: item.image_url || (item.image ? (item.image.startsWith("http") ? item.image : `${baseurl}${item.image}`) : null),
          phone: item.phone || "",
          email: item.email || "",
          city: item.city || "",
          address: item.address || "",
          starting_price: parseFloat(item.starting_price) || 0,
          status: item.status || "active",
          views: parseInt(item.views) || 0,
          clicks: parseInt(item.clicks) || 0,
          featured: item.featured || false,
          rating: item.rating || (4 + Math.random()).toFixed(1),
        }));
        const active = formatted.filter(v => v.status === "active");
        setVendors(active);
        setFilteredVendors(active);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let result = [...vendors];
    if (searchTerm) {
      const s = searchTerm.toLowerCase();
      result = result.filter(v =>
        v.business_name.toLowerCase().includes(s) ||
        v.vendor_name.toLowerCase().includes(s) ||
        v.city.toLowerCase().includes(s)
      );
    }
    if (selectedCategory !== "all") result = result.filter(v => v.category === selectedCategory);
    if (selectedCity !== "all") result = result.filter(v => v.city.toLowerCase() === selectedCity.toLowerCase());
    result.sort((a, b) => (b.featured - a.featured) || (b.views - a.views));
    setFilteredVendors(result);
  };

  const getUniqueCities = () => [...new Set(vendors.map(v => v.city).filter(Boolean))].sort();
  const getCat = (c) => categories[c] || categories.venue;

  const handleCall = (phone) => {
    if (!phone) return message.warning("Phone not available");
    window.location.href = `tel:${phone}`;
  };

  const handleWhatsApp = (phone) => {
    if (!phone) return message.warning("Phone not available");
    window.open(`https://wa.me/91${phone.replace(/\D/g, "")}`, "_blank");
  };

  const handleTrack = async (id) => {
    try { await TrackPromotion(id, "click"); } catch (e) { }
  };

  const toggleFavorite = (id) => {
    const updated = favorites.includes(id)
      ? favorites.filter(f => f !== id)
      : [...favorites, id];
    setFavorites(updated);
    localStorage.setItem("ad_favorites", JSON.stringify(updated));
  };

  const handleShare = (vendor) => {
    if (navigator.share) {
      navigator.share({
        title: vendor.business_name,
        text: `Check out ${vendor.business_name} for your wedding!`,
        url: window.location.href,
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      message.success("Link copied!");
    }
  };

  const formatPrice = (p) => {
    if (!p) return "Contact";
    if (p >= 100000) return `₹${(p / 100000).toFixed(1)}L`;
    if (p >= 1000) return `₹${(p / 1000).toFixed(0)}K`;
    return `₹${p}`;
  };

  const featuredVendors = filteredVendors.filter(v => v.featured);

  return (
    <>
    <LoginHeader />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Poppins:wght@300;400;500;600;700;800&display=swap');

        :root {
          --lux-primary: #ff0055;
          --lux-primary-light: #ff4d88;
          --lux-gold: #d4a853;
          --lux-gold-light: #f0d68a;
          --lux-dark: #1a0a10;
          --lux-dark2: #2d1520;
          --lux-cream: #fdfaf6;
          --lux-cream2: #f8f2ea;
          --lux-text: #3d2028;
          --lux-text-light: #8a6d75;
          --lux-border: #e8ddd5;
          --lux-shadow: 0 8px 32px rgba(26,10,16,.08);
          --lux-shadow-hover: 0 16px 48px rgba(26,10,16,.14);
          --lux-radius: 16px;
        }

        * { box-sizing: border-box; margin: 0; }
        @keyframes luxFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
        @keyframes luxFade { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        @keyframes luxShimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
        @keyframes luxPulse { 0%,100%{opacity:1} 50%{opacity:.7} }
        @keyframes luxSlideIn { from{opacity:0;transform:scale(.95)} to{opacity:1;transform:scale(1)} }
        @keyframes luxGlow { 0%,100%{box-shadow:0 0 20px rgba(212,168,83,.2)} 50%{box-shadow:0 0 40px rgba(212,168,83,.4)} }
        @keyframes luxSpin { 0%{transform:rotate(0)} 100%{transform:rotate(360deg)} }

        /* ========== HERO ========== */
        .lux-hero {
          background: linear-gradient(135deg, var(--lux-dark) 0%, #3d0020 40%, #5a0030 70%, var(--lux-dark) 100%);
          padding: 50px 20px 40px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .lux-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4a853' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          opacity: .5;
        }
        .lux-hero-particles {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
        }
        .lux-hero-particle {
          position: absolute;
          font-size: 14px;
          opacity: .15;
          animation: luxFloat 4s ease infinite;
        }
        .lux-hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 6px 18px;
          background: linear-gradient(135deg, var(--lux-gold), var(--lux-gold-light));
          border-radius: 999px;
          font-family: 'Poppins', sans-serif;
          font-size: 10px;
          font-weight: 700;
          color: var(--lux-dark);
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 16px;
          position: relative;
          z-index: 2;
        }
        .lux-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: 36px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 8px;
          position: relative;
          z-index: 2;
          line-height: 1.2;
        }
        .lux-hero h1 span { color: var(--lux-gold); }
        .lux-hero-sub {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          color: rgba(255,255,255,.5);
          margin: 0;
          position: relative;
          z-index: 2;
          font-weight: 300;
          letter-spacing: .5px;
        }
        .lux-hero-divider {
          width: 60px;
          height: 2px;
          background: linear-gradient(90deg, transparent, var(--lux-gold), transparent);
          margin: 16px auto 0;
          position: relative;
          z-index: 2;
        }

        /* ========== MAIN ========== */
        .lux-page { background: var(--lux-cream); min-height: 100vh; margin-top:1px }
        .lux-main { max-width: 1320px; margin: 0 auto; padding: 28px 24px 50px; }

        /* ========== CATEGORIES ========== */
        .lux-cats-section { margin-bottom: 28px; }
        .lux-cats-title {
          font-family: 'Playfair Display', serif;
          font-size: 14px;
          color: var(--lux-text-light);
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .lux-cats-title::after {
          content: '';
          flex: 1;
          height: 1px;
          background: linear-gradient(90deg, var(--lux-border), transparent);
        }
        .lux-cats-scroll {
          display: flex;
          gap: 10px;
          overflow-x: auto;
          padding: 4px 0 12px;
          scrollbar-width: none;
        }
        .lux-cats-scroll::-webkit-scrollbar { display: none; }
        .lux-cat-pill {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 20px;
          background: #fff;
          border: 1.5px solid var(--lux-border);
          border-radius: 999px;
          cursor: pointer;
          transition: all .3s cubic-bezier(.4,0,.2,1);
          white-space: nowrap;
          font-family: 'Poppins', sans-serif;
          font-size: 12.5px;
          font-weight: 500;
          color: var(--lux-text-light);
          flex-shrink: 0;
        }
        .lux-cat-pill:hover {
          border-color: var(--lux-primary);
          color: var(--lux-primary);
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(255,0,85,.1);
        }
        .lux-cat-pill.active {
          background: linear-gradient(135deg, var(--lux-primary), var(--lux-primary-light));
          color: #fff;
          border-color: transparent;
          box-shadow: 0 6px 20px rgba(255,0,85,.25);
          transform: translateY(-2px);
          font-weight: 600;
        }
        .lux-cat-pill-emoji { font-size: 16px; }

        /* ========== TOOLBAR ========== */
        .lux-toolbar {
          display: flex;
          gap: 14px;
          margin-bottom: 24px;
          align-items: center;
          flex-wrap: wrap;
          background: #fff;
          padding: 14px 18px;
          border-radius: var(--lux-radius);
          border: 1px solid var(--lux-border);
          box-shadow: var(--lux-shadow);
        }
        .lux-search-wrap {
          flex: 1;
          min-width: 260px;
          position: relative;
        }
        .lux-search-wrap svg {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--lux-text-light);
          font-size: 14px;
        }
        .lux-search-input {
          width: 100%;
          padding: 12px 16px 12px 44px;
          border: 1.5px solid var(--lux-border);
          border-radius: 12px;
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          color: var(--lux-text);
          outline: none;
          background: var(--lux-cream);
          transition: all .3s;
        }
        .lux-search-input::placeholder { color: #bbb; }
        .lux-search-input:focus {
          border-color: var(--lux-primary);
          box-shadow: 0 0 0 3px rgba(255,0,85,.08);
          background: #fff;
        }
        .lux-city-select .ant-select-selector {
          border: 1.5px solid var(--lux-border) !important;
          border-radius: 12px !important;
          height: 46px !important;
          background: var(--lux-cream) !important;
          font-family: 'Poppins', sans-serif !important;
        }
        .lux-results-tag {
          padding: 6px 16px;
          background: linear-gradient(135deg, #fff0f3, #ffe4ec);
          border: 1px solid #ffd3df;
          border-radius: 999px;
          font-family: 'Poppins', sans-serif;
          font-size: 12px;
          font-weight: 600;
          color: var(--lux-primary);
        }

        /* ========== FEATURED BANNER ========== */
        .lux-featured-section { margin-bottom: 32px; }
        .lux-featured-title {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          color: var(--lux-dark);
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .lux-featured-title svg { color: var(--lux-gold); }
        .lux-featured-scroll {
          display: flex;
          gap: 16px;
          overflow-x: auto;
          padding: 4px 0 16px;
          scrollbar-width: none;
        }
        .lux-featured-scroll::-webkit-scrollbar { display: none; }
        .lux-featured-card {
          min-width: 340px;
          background: linear-gradient(135deg, var(--lux-dark), var(--lux-dark2));
          border-radius: 18px;
          overflow: hidden;
          display: flex;
          cursor: pointer;
          transition: all .4s;
          position: relative;
          border: 1px solid rgba(212,168,83,.2);
          flex-shrink: 0;
        }
        .lux-featured-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 48px rgba(26,10,16,.3);
          border-color: var(--lux-gold);
        }
        .lux-featured-card::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: conic-gradient(from 0deg, transparent, rgba(212,168,83,.1), transparent);
          animation: luxSpin 6s linear infinite;
          pointer-events: none;
        }
        .lux-featured-img {
          width: 140px;
          min-height: 160px;
          overflow: hidden;
          position: relative;
        }
        .lux-featured-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .5s;
        }
        .lux-featured-card:hover .lux-featured-img img { transform: scale(1.08); }
        .lux-featured-body {
          flex: 1;
          padding: 18px 16px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          z-index: 2;
        }
        .lux-featured-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 3px 10px;
          background: linear-gradient(135deg, var(--lux-gold), var(--lux-gold-light));
          border-radius: 6px;
          font-family: 'Poppins', sans-serif;
          font-size: 8px;
          font-weight: 800;
          color: var(--lux-dark);
          text-transform: uppercase;
          letter-spacing: 1px;
          width: fit-content;
          margin-bottom: 8px;
          animation: luxGlow 3s ease infinite;
        }
        .lux-featured-name {
          font-family: 'Playfair Display', serif;
          font-size: 17px;
          font-weight: 700;
          color: #fff;
          margin: 0 0 4px;
          line-height: 1.3;
        }
        .lux-featured-sub {
          font-family: 'Poppins', sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,.4);
          margin: 0 0 10px;
        }
        .lux-featured-price {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 800;
          color: var(--lux-gold);
        }
        .lux-featured-price span {
          font-family: 'Poppins', sans-serif;
          font-size: 10px;
          color: rgba(255,255,255,.4);
          font-weight: 400;
          margin-left: 4px;
        }

        /* ========== GRID ========== */
        .lux-grid-title {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          color: var(--lux-dark);
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .lux-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 18px;
        }

        /* ========== CARD ========== */
        .lux-card {
          background: #fff;
          border-radius: var(--lux-radius);
          overflow: hidden;
          border: 1px solid var(--lux-border);
          transition: all .4s cubic-bezier(.4,0,.2,1);
          animation: luxFade .5s ease;
          position: relative;
        }
        .lux-card:hover {
          transform: translateY(-6px);
          box-shadow: var(--lux-shadow-hover);
          border-color: rgba(255,0,85,.15);
        }

        .lux-card-img-wrap {
          position: relative;
          height: 180px;
          overflow: hidden;
        }
        .lux-card-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .6s cubic-bezier(.4,0,.2,1);
        }
        .lux-card:hover .lux-card-img-wrap img { transform: scale(1.08); }
        .lux-card-img-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(0,0,0,.1) 0%, transparent 30%, rgba(26,10,16,.7) 100%);
        }

        .lux-card-top-bar {
          position: absolute;
          top: 10px;
          left: 10px;
          right: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 3;
        }
        .lux-card-ad-badge {
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 3px 10px;
          background: rgba(0,0,0,.5);
          backdrop-filter: blur(10px);
          border-radius: 6px;
          font-family: 'Poppins', sans-serif;
          font-size: 8px;
          font-weight: 700;
          color: rgba(255,255,255,.6);
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .lux-card-ad-badge svg { color: var(--lux-gold); font-size: 8px; }
        .lux-card-top-actions { display: flex; gap: 6px; }
        .lux-card-icon-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: rgba(0,0,0,.4);
          backdrop-filter: blur(10px);
          border: none;
          color: #fff;
          font-size: 12px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .3s;
        }
        .lux-card-icon-btn:hover { background: var(--lux-primary); transform: scale(1.1); }
        .lux-card-icon-btn.fav-active { background: var(--lux-primary); }

        .lux-card-cat-tag {
          position: absolute;
          bottom: 10px;
          left: 10px;
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 4px 12px;
          border-radius: 8px;
          color: #fff;
          font-family: 'Poppins', sans-serif;
          font-size: 10px;
          font-weight: 700;
          z-index: 3;
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255,255,255,.15);
        }
        .lux-card-rating {
          position: absolute;
          bottom: 10px;
          right: 10px;
          display: flex;
          align-items: center;
          gap: 3px;
          padding: 3px 10px;
          background: rgba(0,0,0,.5);
          backdrop-filter: blur(10px);
          border-radius: 6px;
          font-family: 'Poppins', sans-serif;
          font-size: 11px;
          font-weight: 700;
          color: #ffd700;
          z-index: 3;
        }

        .lux-card-body { padding: 16px 18px; }
        .lux-card-name {
          font-family: 'Playfair Display', serif;
          font-size: 16px;
          font-weight: 700;
          color: var(--lux-dark);
          margin: 0 0 2px;
          line-height: 1.3;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .lux-card-vendor {
          font-family: 'Poppins', sans-serif;
          font-size: 11px;
          color: var(--lux-text-light);
          margin: 0 0 10px;
        }
        .lux-card-vendor span { color: var(--lux-primary); font-weight: 600; }
        .lux-card-desc {
          font-family: 'Poppins', sans-serif;
          font-size: 12px;
          color: #aaa;
          line-height: 1.6;
          margin: 0 0 12px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .lux-card-meta-row {
          display: flex;
          gap: 12px;
          margin-bottom: 14px;
          flex-wrap: wrap;
        }
        .lux-card-meta-chip {
          display: flex;
          align-items: center;
          gap: 4px;
          font-family: 'Poppins', sans-serif;
          font-size: 11px;
          color: var(--lux-text-light);
          font-weight: 500;
        }
        .lux-card-meta-chip svg { color: var(--lux-primary); font-size: 10px; }

        .lux-card-price-strip {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 14px;
          background: linear-gradient(135deg, var(--lux-dark), var(--lux-dark2));
          border-radius: 12px;
          margin-bottom: 14px;
          position: relative;
          overflow: hidden;
        }
        .lux-card-price-strip::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(212,168,83,.08), transparent);
        }
        .lux-card-price-label {
          font-family: 'Poppins', sans-serif;
          font-size: 9px;
          color: rgba(255,255,255,.4);
          text-transform: uppercase;
          letter-spacing: .5px;
          font-weight: 600;
          position: relative;
          z-index: 2;
        }
        .lux-card-price-val {
          font-family: 'Playfair Display', serif;
          font-size: 19px;
          font-weight: 800;
          color: var(--lux-gold);
          position: relative;
          z-index: 2;
        }
        .lux-card-price-deal {
          padding: 3px 10px;
          background: var(--lux-primary);
          color: #fff;
          border-radius: 6px;
          font-family: 'Poppins', sans-serif;
          font-size: 9px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 3px;
          position: relative;
          z-index: 2;
        }

        .lux-card-ctas { display: flex; gap: 8px; }
        .lux-cta-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 10px 8px;
          border: none;
          border-radius: 10px;
          font-family: 'Poppins', sans-serif;
          font-size: 11.5px;
          font-weight: 700;
          cursor: pointer;
          transition: all .3s cubic-bezier(.4,0,.2,1);
          position: relative;
          overflow: hidden;
        }
        .lux-cta-btn::after {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.2), transparent);
          transition: .6s;
        }
        .lux-cta-btn:hover::after { left: 100%; }
        .lux-cta-btn:hover { transform: translateY(-2px); }
        .lux-cta-call {
          background: linear-gradient(135deg, var(--lux-primary), var(--lux-primary-light));
          color: #fff;
          box-shadow: 0 4px 14px rgba(255,0,85,.2);
        }
        .lux-cta-wa {
          background: linear-gradient(135deg, #25d366, #128c7e);
          color: #fff;
          box-shadow: 0 4px 14px rgba(37,211,102,.2);
        }
        .lux-cta-view {
          background: var(--lux-cream2);
          color: var(--lux-dark);
          flex: none;
          width: 42px;
          min-width: 42px;
          padding: 0;
          border: 1.5px solid var(--lux-border);
        }
        .lux-cta-view:hover { background: var(--lux-dark); color: #fff; border-color: var(--lux-dark); }

        .lux-card-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          padding: 6px;
          background: var(--lux-cream);
          border-top: 1px solid var(--lux-border);
          font-family: 'Poppins', sans-serif;
          font-size: 8px;
          color: #ccc;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .lux-card-footer svg { font-size: 7px; color: #ddd; }

        /* ========== EMPTY ========== */
        .lux-empty {
          text-align: center;
          padding: 70px 20px;
          background: #fff;
          border-radius: var(--lux-radius);
          border: 2px dashed var(--lux-border);
        }
        .lux-empty-icon { font-size: 56px; margin-bottom: 16px; }
        .lux-empty h3 {
          font-family: 'Playfair Display', serif;
          font-size: 22px;
          color: var(--lux-dark);
          margin: 0 0 6px;
        }
        .lux-empty p {
          font-family: 'Poppins', sans-serif;
          color: #bbb;
          font-size: 13px;
        }

        /* ========== LOADING ========== */
        .lux-loading {
          text-align: center;
          padding: 80px;
        }
        .lux-loading-spinner {
          width: 48px;
          height: 48px;
          border: 3px solid var(--lux-border);
          border-top-color: var(--lux-primary);
          border-radius: 50%;
          animation: luxSpin 1s linear infinite;
          margin: 0 auto 16px;
        }
        .lux-loading p {
          font-family: 'Poppins', sans-serif;
          color: var(--lux-text-light);
          font-size: 13px;
        }

        /* ========== MODAL ========== */
        .lux-modal-bg {
          position: fixed;
          inset: 0;
          background: rgba(26,10,16,.7);
          backdrop-filter: blur(8px);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px;
        }
        .lux-modal {
          background: #fff;
          border-radius: 24px;
          width: 100%;
          max-width: 520px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 32px 80px rgba(0,0,0,.4);
          animation: luxSlideIn .35s ease;
        }
        .lux-modal::-webkit-scrollbar { width: 4px; }
        .lux-modal::-webkit-scrollbar-thumb { background: var(--lux-border); border-radius: 4px; }
        .lux-modal-header {
          position: relative;
          height: 260px;
          overflow: hidden;
          border-radius: 24px 24px 0 0;
        }
        .lux-modal-header img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .lux-modal-header-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(0,0,0,.2) 0%, transparent 40%, rgba(26,10,16,.8) 100%);
        }
        .lux-modal-close {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: rgba(0,0,0,.5);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255,255,255,.1);
          color: #fff;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .3s;
          z-index: 5;
        }
        .lux-modal-close:hover { background: var(--lux-primary); border-color: var(--lux-primary); }
        .lux-modal-header-info {
          position: absolute;
          bottom: 16px;
          left: 20px;
          right: 20px;
          z-index: 4;
        }
        .lux-modal-header-name {
          font-family: 'Playfair Display', serif;
          font-size: 24px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 4px;
          text-shadow: 0 2px 8px rgba(0,0,0,.3);
        }
        .lux-modal-header-vendor {
          font-family: 'Poppins', sans-serif;
          font-size: 12px;
          color: rgba(255,255,255,.6);
        }

        .lux-modal-body { padding: 24px; }
        .lux-modal-cat-badge {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          padding: 5px 16px;
          border-radius: 999px;
          color: #fff;
          font-family: 'Poppins', sans-serif;
          font-size: 11px;
          font-weight: 700;
          margin-bottom: 16px;
        }
        .lux-modal-desc {
          font-family: 'Poppins', sans-serif;
          font-size: 13.5px;
          color: var(--lux-text-light);
          line-height: 1.8;
          margin: 0 0 20px;
        }
        .lux-modal-info-grid {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin-bottom: 20px;
        }
        .lux-modal-info-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          background: var(--lux-cream);
          border-radius: 12px;
          font-family: 'Poppins', sans-serif;
          font-size: 13px;
          color: var(--lux-text);
          border: 1px solid var(--lux-border);
        }
        .lux-modal-info-row svg { color: var(--lux-primary); font-size: 14px; min-width: 16px; }
        .lux-modal-price-box {
          text-align: center;
          padding: 20px;
          background: linear-gradient(135deg, var(--lux-dark), var(--lux-dark2));
          border-radius: 16px;
          margin-bottom: 20px;
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(212,168,83,.15);
        }
        .lux-modal-price-box::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(212,168,83,.06), transparent);
        }
        .lux-modal-price-label {
          font-family: 'Poppins', sans-serif;
          font-size: 10px;
          color: rgba(255,255,255,.4);
          text-transform: uppercase;
          letter-spacing: 2px;
          font-weight: 600;
          position: relative;
          z-index: 2;
        }
        .lux-modal-price-amount {
          font-family: 'Playfair Display', serif;
          font-size: 34px;
          font-weight: 900;
          color: var(--lux-gold);
          margin: 6px 0;
          position: relative;
          z-index: 2;
        }
        .lux-modal-price-note {
          font-family: 'Poppins', sans-serif;
          font-size: 10px;
          color: rgba(255,255,255,.3);
          position: relative;
          z-index: 2;
        }
        .lux-modal-ctas { display: flex; gap: 10px; }
        .lux-modal-ctas .lux-cta-btn { padding: 13px 10px; font-size: 13px; }
        .lux-modal-email-btn {
          width: 100%;
          margin-top: 10px;
          background: var(--lux-cream);
          color: var(--lux-dark);
          border: 1.5px solid var(--lux-border);
          padding: 12px;
          font-size: 13px;
        }
        .lux-modal-email-btn:hover {
          background: var(--lux-dark);
          color: #fff;
          border-color: var(--lux-dark);
        }

        /* ========== RESPONSIVE ========== */
        @media (max-width: 768px) {
          .lux-hero h1 { font-size: 26px; }
          .lux-hero-sub { font-size: 12px; }
          .lux-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
          .lux-card-img-wrap { height: 140px; }
          .lux-card-desc { display: none; }
          .lux-card-body { padding: 12px 14px; }
          .lux-card-name { font-size: 13.5px; }
          .lux-cta-btn { font-size: 10px; padding: 8px 4px; }
          .lux-toolbar { flex-direction: column; padding: 12px; }
          .lux-search-wrap { min-width: 100%; }
          .lux-featured-card { min-width: 300px; }
          .lux-featured-img { width: 110px; }
        }
        @media (max-width: 480px) {
          .lux-hero { padding: 36px 16px 30px; }
          .lux-hero h1 { font-size: 22px; }
          .lux-grid { grid-template-columns: 1fr; }
          .lux-main { padding: 20px 14px 40px; }
        }
      `}</style>
      

      <div className="lux-page">

        {/* ==================== HERO ==================== */}
        <div className="lux-hero">
          <div className="lux-hero-particles">
            {["💍", "✨", "🌹", "💐", "🎊", "💎", "🕊️", "🌸"].map((e, i) => (
              <span
                key={i}
                className="lux-hero-particle"
                style={{
                  top: `${10 + (i * 12) % 80}%`,
                  left: `${5 + (i * 13) % 90}%`,
                  animationDelay: `${i * .5}s`,
                  fontSize: `${14 + (i % 4) * 4}px`,
                }}
              >{e}</span>
            ))}
          </div>

          <div className="lux-hero-badge">
            <FaGem size={10} /> Premium Wedding Partners
          </div>
          <h1>
            Wedding <span>Advertisements</span>
          </h1>
          <p className="lux-hero-sub">
            Handpicked vendors to make your celebration extraordinary
          </p>
          <div className="lux-hero-divider" />
        </div>

        <div className="lux-main">

          {/* ==================== CATEGORIES ==================== */}
          <div className="lux-cats-section">
            <div className="lux-cats-title">
              Browse by Category
            </div>
            <div className="lux-cats-scroll">
              {Object.entries(categories).map(([key, cat]) => (
                <div
                  key={key}
                  className={`lux-cat-pill ${selectedCategory === key ? "active" : ""}`}
                  onClick={() => setSelectedCategory(key)}
                >
                  <span className="lux-cat-pill-emoji">{cat.icon}</span>
                  {cat.label}
                </div>
              ))}
            </div>
          </div>

          {/* ==================== TOOLBAR ==================== */}
          <div className="lux-toolbar">
            <div className="lux-search-wrap">
              <FaSearch />
              <input
                type="text"
                placeholder="Search vendors, services, cities..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="lux-search-input"
              />
            </div>
            <Select
              value={selectedCity}
              onChange={setSelectedCity}
              className="lux-city-select"
              style={{ width: 200 }}
            >
              <Option value="all">🌍 All Cities</Option>
              {getUniqueCities().map(c => (
                <Option key={c} value={c}>📍 {c}</Option>
              ))}
            </Select>
            <span className="lux-results-tag">
              {filteredVendors.length} Ad{filteredVendors.length !== 1 ? "s" : ""} Found
            </span>
          </div>

          {/* ==================== FEATURED ==================== */}
          {featuredVendors.length > 0 && (
            <div className="lux-featured-section">
              <div className="lux-featured-title">
                <FaCrown /> Featured Partners
              </div>
              <div className="lux-featured-scroll">
                {featuredVendors.map(v => {
                  const cat = getCat(v.category);
                  return (
                    <div
                      key={`featured-${v.id}`}
                      className="lux-featured-card"
                      onClick={() => setSelectedVendor(v)}
                    >
                      <div className="lux-featured-img">
                        <img
                          src={v.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(v.business_name)}&background=d4a853&color=1a0a10&size=400`}
                          alt={v.business_name}
                          onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(v.business_name)}&background=d4a853&color=1a0a10&size=400`; }}
                        />
                      </div>
                      <div className="lux-featured-body">
                        <div className="lux-featured-badge">
                          <FaCrown size={8} /> PREMIUM PARTNER
                        </div>
                        <h3 className="lux-featured-name">{v.business_name}</h3>
                        <p className="lux-featured-sub">
                          {cat.icon} {cat.label} • {v.city || "India"}
                        </p>
                        <div className="lux-featured-price">
                          {formatPrice(v.starting_price)}
                          <span>onwards</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* ==================== GRID ==================== */}
          {loading ? (
            <div className="lux-loading">
              <div className="lux-loading-spinner" />
              <p>Curating the best vendors for you...</p>
            </div>
          ) : filteredVendors.length === 0 ? (
            <div className="lux-empty">
              <div className="lux-empty-icon">💎</div>
              <h3>No Advertisements Found</h3>
              <p>Try adjusting your filters to discover more vendors</p>
            </div>
          ) : (
            <>
              <div className="lux-grid-title">
                <FaBullhorn /> All Advertisements
              </div>
              <div className="lux-grid">
                {filteredVendors.map(vendor => {
                  const cat = getCat(vendor.category);
                  const isFav = favorites.includes(vendor.id);
                  return (
                    <div key={vendor.id} className="lux-card">

                      <div className="lux-card-img-wrap">
                        <img
                          src={vendor.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(vendor.business_name)}&background=ff0055&color=fff&size=400`}
                          alt={vendor.business_name}
                          onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(vendor.business_name)}&background=ff0055&color=fff&size=400`; }}
                        />
                        <div className="lux-card-img-overlay" />

                        <div className="lux-card-top-bar">
                          <div className="lux-card-ad-badge">
                            <FaAd /> Sponsored
                          </div>
                          <div className="lux-card-top-actions">
                            <button
                              className={`lux-card-icon-btn ${isFav ? "fav-active" : ""}`}
                              onClick={e => { e.stopPropagation(); toggleFavorite(vendor.id); }}
                            >
                              <FaHeart />
                            </button>
                            <button
                              className="lux-card-icon-btn"
                              onClick={e => { e.stopPropagation(); handleShare(vendor); }}
                            >
                              <FaShareAlt />
                            </button>
                          </div>
                        </div>

                        <div
                          className="lux-card-cat-tag"
                          style={{ background: `${cat.color}cc` }}
                        >
                          {cat.icon} {cat.label}
                        </div>

                        <div className="lux-card-rating">
                          <FaStar size={10} /> {vendor.rating}
                        </div>
                      </div>

                      <div className="lux-card-body">
                        <h3 className="lux-card-name">{vendor.business_name}</h3>
                        <p className="lux-card-vendor">
                          by <span>{vendor.vendor_name}</span>
                        </p>
                        <p className="lux-card-desc">{vendor.description}</p>

                        <div className="lux-card-meta-row">
                          <span className="lux-card-meta-chip">
                            <FaMapMarkerAlt /> {vendor.city || "India"}
                          </span>
                          <span className="lux-card-meta-chip">
                            <FaEye /> {vendor.views} views
                          </span>
                          {vendor.featured && (
                            <span className="lux-card-meta-chip" style={{ color: "#d4a853" }}>
                              <FaCrown style={{ color: "#d4a853" }} /> Premium
                            </span>
                          )}
                        </div>

                        <div className="lux-card-price-strip">
                          <div>
                            <div className="lux-card-price-label">Starting From</div>
                            <div className="lux-card-price-val">{formatPrice(vendor.starting_price)}</div>
                          </div>
                          <div className="lux-card-price-deal">
                            <FaTag size={8} /> OFFER
                          </div>
                        </div>

                        <div className="lux-card-ctas">
                          <button
                            className="lux-cta-btn lux-cta-call"
                            onClick={() => { handleCall(vendor.phone); handleTrack(vendor.id); }}
                          >
                            <FaPhone size={11} /> Call
                          </button>
                          <button
                            className="lux-cta-btn lux-cta-wa"
                            onClick={() => { handleWhatsApp(vendor.phone); handleTrack(vendor.id); }}
                          >
                            <FaWhatsapp size={13} /> WhatsApp
                          </button>
                          <button
                            className="lux-cta-btn lux-cta-view"
                            onClick={() => setSelectedVendor(vendor)}
                          >
                            <FaArrowRight size={12} />
                          </button>
                        </div>
                      </div>

                      <div className="lux-card-footer">
                        <FaBullhorn /> Sponsored Advertisement
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      {/* ==================== MODAL ==================== */}
      {selectedVendor && (
        <div className="lux-modal-bg" onClick={() => setSelectedVendor(null)}>
          <div className="lux-modal" onClick={e => e.stopPropagation()}>
            <div className="lux-modal-header">
              <img
                src={selectedVendor.image || `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedVendor.business_name)}&background=ff0055&color=fff&size=600`}
                alt={selectedVendor.business_name}
                onError={e => { e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedVendor.business_name)}&background=ff0055&color=fff&size=600`; }}
              />
              <div className="lux-modal-header-overlay" />
              <button className="lux-modal-close" onClick={() => setSelectedVendor(null)}>
                <FaTimes />
              </button>
              <div className="lux-modal-header-info">
                <h2 className="lux-modal-header-name">{selectedVendor.business_name}</h2>
                <p className="lux-modal-header-vendor">by {selectedVendor.vendor_name}</p>
              </div>
            </div>

            <div className="lux-modal-body">
              <div
                className="lux-modal-cat-badge"
                style={{ background: getCat(selectedVendor.category).color }}
              >
                {getCat(selectedVendor.category).icon}{" "}
                {getCat(selectedVendor.category).label}
              </div>

              {selectedVendor.featured && (
                <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "4px 14px",
                  background: "linear-gradient(135deg, #d4a853, #f0d68a)",
                  borderRadius: 999,
                  fontSize: 10,
                  fontWeight: 800,
                  color: "#1a0a10",
                  marginLeft: 8,
                  marginBottom: 16,
                }}>
                  <FaCrown size={9} /> PREMIUM PARTNER
                </div>
              )}

              <p className="lux-modal-desc">{selectedVendor.description}</p>

              <div className="lux-modal-info-grid">
                <div className="lux-modal-info-row">
                  <FaMapMarkerAlt />
                  {selectedVendor.city}{selectedVendor.address ? ` — ${selectedVendor.address}` : ""}
                </div>
                {selectedVendor.phone && (
                  <div className="lux-modal-info-row">
                    <FaPhone /> {selectedVendor.phone}
                  </div>
                )}
                {selectedVendor.email && (
                  <div className="lux-modal-info-row">
                    <FaEnvelope /> {selectedVendor.email}
                  </div>
                )}
                <div className="lux-modal-info-row">
                  <FaEye /> {selectedVendor.views} total views
                </div>
                <div className="lux-modal-info-row">
                  <FaStar style={{ color: "#ffd700" }} />
                  <span style={{ fontWeight: 700, color: "#d4a853" }}>
                    {selectedVendor.rating}
                  </span>
                  Rating
                </div>
              </div>

              <div className="lux-modal-price-box">
                <div className="lux-modal-price-label">Starting Price</div>
                <div className="lux-modal-price-amount">
                  {formatPrice(selectedVendor.starting_price)}
                </div>
                <div className="lux-modal-price-note">
                  onwards · Contact for detailed quote
                </div>
              </div>

              <div className="lux-modal-ctas">
                <button
                  className="lux-cta-btn lux-cta-call"
                  onClick={() => { handleCall(selectedVendor.phone); handleTrack(selectedVendor.id); }}
                >
                  <FaPhone size={13} /> Call Now
                </button>
                <button
                  className="lux-cta-btn lux-cta-wa"
                  onClick={() => { handleWhatsApp(selectedVendor.phone); handleTrack(selectedVendor.id); }}
                >
                  <FaWhatsapp size={15} /> WhatsApp
                </button>
              </div>

              {selectedVendor.email && (
                <button
                  className="lux-cta-btn lux-modal-email-btn"
                  onClick={() => { window.location.href = `mailto:${selectedVendor.email}`; }}
                >
                  <FaEnvelope size={13} /> Send Email
                </button>
              )}
            </div>
          </div>
        </div>
      )}
        <Footer />
    </>
  );
};

export default Promotions;